import { Link } from 'react-router-dom';
import { SIDEBAR_MENUS } from '../data/pagesContent.js';
import { withBasePath } from '../utils/paths.js';

/**
 * Shared inner-page shell: sidebar + banner + content (mirrors PHP inner-layout).
 */
export default function InnerPage({
  slug,
  heading,
  lead,
  breadcrumb,
  banner,
  section,
  children,
}) {
  const sidebar = section ? SIDEBAR_MENUS[section] : null;
  const crumb = breadcrumb || heading;

  return (
    <main id="main" className={`inner-layout${sidebar ? ' inner-layout--sidebar' : ''}`}>
      <div className="container inner-layout__wrap">
        {sidebar && (
          <aside className="inner-sidebar" aria-label="Section navigation">
            <h2 className="inner-sidebar__title">{sidebar.title}</h2>
            <nav className="inner-sidebar__nav">
              <ul className="inner-sidebar__list">
                {Object.entries(sidebar.items).map(([itemSlug, label]) => {
                  const active = itemSlug === slug;
                  return (
                    <li
                      key={itemSlug}
                      className={`inner-sidebar__item${active ? ' inner-sidebar__item--active' : ''}`}
                    >
                      <Link
                        to={`/${itemSlug}`}
                        className="inner-sidebar__link"
                        aria-current={active ? 'page' : undefined}
                      >
                        {label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </aside>
        )}

        <div className="inner-layout__main">
          <section className="inner-banner" aria-labelledby="inner-heading">
            <div className="inner-banner__content">
              <nav className="inner-breadcrumb" aria-label="Breadcrumb">
                <Link to="/">Home</Link>
                <span className="inner-breadcrumb__sep" aria-hidden="true">
                  ›
                </span>
                <span aria-current="page">{crumb}</span>
              </nav>
              <h1 id="inner-heading" className="inner-banner__title">
                {heading}
              </h1>
              {lead ? <p className="inner-banner__lead">{lead}</p> : null}
            </div>
            <div className="inner-banner__media" aria-hidden="true">
              <div className="inner-banner__media-shape" />
              <img
                className="inner-banner__img"
                src={withBasePath(banner)}
                alt=""
                width="520"
                height="340"
                loading="eager"
                decoding="async"
              />
            </div>
          </section>
          <div className="inner-layout__content">{children}</div>
        </div>
      </div>
    </main>
  );
}
